
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="实例方法" fileName="instance-method.md" />
        <demo-block>
        <div><p>1、通过实例方法<code>startEditingCell({ rowKey, colKey, defaultValue })</code>编辑指定的单元格</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;startEditingCell(0,'name')&quot;&gt;编辑单元格0-0&lt;/button&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;startEditingCell(2,'hobby','')&quot;&gt;
            编辑并清空单元格2-2
        &lt;/button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table
            ref=&quot;tableRef&quot;
            rowKeyFieldName=&quot;rowKey&quot;
            :max-height=&quot;300&quot;
            :fixed-header=&quot;true&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :editOption=&quot;editOption&quot;
            :row-style-option=&quot;rowStyleOption&quot;
            border-y
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // edit option 可控单元格编辑
                editOption: {
                    // cell value change
                    cellValueChange: ({ row, column }) =&gt; {
                        console.log(&quot;cellValueChange row::&quot;, row);
                        console.log(&quot;cellValueChange column::&quot;, column);
                    },
                },
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;&quot;,
                        width: 50,
                        align: &quot;center&quot;,
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;name&quot;,
                        title: &quot;Name&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                        edit: true,
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;date&quot;,
                        title: &quot;Date&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                        edit: true,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;hobby&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;left&quot;,
                        width: &quot;30%&quot;,
                        edit: true,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;address&quot;,
                        title: &quot;Address&quot;,
                        align: &quot;left&quot;,
                        width: &quot;40%&quot;,
                        edit: true,
                    },
                ],
                // table data
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                        rowKey: 0,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                        rowKey: 1,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                        rowKey: 2,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                        rowKey: 3,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                        rowKey: 4,
                    },
                ],
            };
        },
        methods: {
            // start editing cell
            startEditingCell(rowKey, colKey, defaultValue) {
                this.$refs[&quot;tableRef&quot;].startEditingCell({ rowKey, colKey, defaultValue });
            },
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.startEditingCell(0,'name')}}},[_vm._v("编辑单元格0-0")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.startEditingCell(2,'hobby','')}}},[_vm._v("\n            编辑并清空单元格2-2\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{ref:"tableRef",attrs:{"rowKeyFieldName":"rowKey","max-height":300,"fixed-header":true,"columns":_vm.columns,"table-data":_vm.tableData,"editOption":_vm.editOption,"row-style-option":_vm.rowStyleOption,"border-y":""}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // edit option 可控单元格编辑
                editOption: {
                    // cell value change
                    cellValueChange: ({ row, column }) => {
                        console.log("cellValueChange row::", row);
                        console.log("cellValueChange column::", column);
                    },
                },
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "",
                        width: 50,
                        align: "center",
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: "name",
                        key: "name",
                        title: "Name",
                        align: "left",
                        width: "15%",
                        edit: true,
                    },
                    {
                        field: "date",
                        key: "date",
                        title: "Date",
                        align: "left",
                        width: "15%",
                        edit: true,
                    },
                    {
                        field: "hobby",
                        key: "hobby",
                        title: "Hobby",
                        align: "left",
                        width: "30%",
                        edit: true,
                    },
                    {
                        field: "address",
                        key: "address",
                        title: "Address",
                        align: "left",
                        width: "40%",
                        edit: true,
                    },
                ],
                // table data
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shanghai",
                        rowKey: 0,
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                        rowKey: 1,
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                        rowKey: 2,
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                        rowKey: 3,
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                        rowKey: 4,
                    },
                ],
            };
        },
        methods: {
            // start editing cell
            startEditingCell(rowKey, colKey, defaultValue) {
                this.$refs["tableRef"].startEditingCell({ rowKey, colKey, defaultValue });
            },
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  